import Marquee from "react-fast-marquee";

const items = [
  "Natural Alchemy",
  "Clinical Precision",
  "Longevity",
  "Third-Party Tested",
  "Nootropics",
  "Adaptogens",
  "Probiotics",
];

export const EditorialMarquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-[#1a1f1b]/10 bg-[#eae5dc] py-8"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif-display text-4xl sm:text-6xl tracking-tight text-[#1a1f1b] px-8">
              {t}
            </span>
            <span className="h-3 w-3 rounded-full bg-[#e85d04]" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};
